/**
* Brand Theme Configuration
* Central source of truth for application colors, gradients, and shared styles.
*/
export const BrandTheme = {
    colors: {
        primary: '#1949e4ff', // Template default purple/blue
        secondary: '#8592a3',
        success: '#71dd37',
        danger: '#ff3e1d',
        warning: '#ffab00',
        info: '#03c3ec',
        dark: '#233446',
        light: '#fff',
        body: '#f5f5f9',
        text: {
            primary: '#334155', // Slate-700 (Darker for readability)
            secondary: '#64748b', // Slate-500
            muted: '#94a3b8'  // Slate-400
        }
    },
    gradients: {
        primary: 'linear-gradient(135deg, #696cff 0%, #6062e8 100%)',
        info: 'linear-gradient(135deg, #03c3ec 0%, #02a8cc 100%)',
        success: 'linear-gradient(135deg, #71dd37 0%, #5fbf2c 100%)',
        purple: 'linear-gradient(135deg, #c483ff 0%, #aa64f2 100%)', // Repair Theme
        financial: 'linear-gradient(135deg, #233446 0%, #435971 100%)',
        inventory: 'linear-gradient(135deg, #ffab00 0%, #e69a00 100%)',
        customers: 'linear-gradient(135deg, #03c3ec 0%, #02a8cc 100%)',
    },
    shadows: {
        card: '0 2px 6px 0 rgba(67, 89, 113, 0.12)',
        premium: '0 10px 30px 0 rgba(67, 89, 113, 0.15)',
        sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    },
    borderRadius: {
        card: '0.5rem',
        btn: '0.375rem',
    },
    trends: {
        up: {
            color: '#71dd37',
            icon: 'bx bx-trending-up',
            label: '↑'
        },
        down: {
            color: '#ff3e1d',
            icon: 'bx bx-trending-down',
            label: '↓'
        }
    },
    icons: {
        size: {
            sm: '1rem',
            md: '1.25rem',
            lg: '1.5rem',
            xl: '2rem'
        }
    },
    Typography: {
        styles: {
            label: {
                fontSize: '0.75rem',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                color: '#a1acb8'
            }
        }
    }
};

export default BrandTheme;
